import type { RouteRecordRaw } from 'vue-router';

export const oauthConsentRoute: RouteRecordRaw = {
  path: '/oauth/consent',
  name: 'OauthConsent',
  component: () => import('./pages/OauthConsentPage.vue'),
  meta: {
    layout: 'empty',
    public: false,
  },
};
